import React from 'react';

const viLoopImage = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 16"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g fill="none" fillRule="evenodd">
      {/* eslint-disable-next-line max-len */}
      <path d="M11.2004 14H5.0213C4.61743 14 4.41549 14 4.32198 13.9201C4.24084 13.8508 4.19778 13.7469 4.20616 13.6405C4.2158 13.5179 4.3586 13.3751 4.64418 13.0895L10.3128 7.42091C10.5768 7.15691 10.7088 7.0249 10.861 6.97544C10.9949 6.93193 11.1392 6.93193 11.2731 6.97544C11.4253 7.0249 11.5573 7.1569 11.8213 7.42091L14.4004 10V10.8M11.2004 14C12.3205 14 12.8805 14 13.3084 13.782C13.6847 13.5903 13.9907 13.2843 14.1824 12.908C14.4004 12.4802 14.4004 11.9201 14.4004 10.8M11.2004 14H5.60039C4.48029 14 3.92023 14 3.49241 13.782C3.11609 13.5903 2.81012 13.2843 2.61838 12.908C2.40039 12.4802 2.40039 11.9201 2.40039 10.8V5.2C2.40039 4.0799 2.40039 3.51984 2.61838 3.09202C2.81012 2.71569 3.11609 2.40973 3.49241 2.21799C3.92023 2 4.48029 2 5.60039 2H11.2004C12.3205 2 12.8805 2 13.3084 2.21799C13.6847 2.40973 13.9907 2.71569 14.1824 3.09202C14.4004 3.51984 14.4004 4.0799 14.4004 5.2V10.8M7.40039 5.66667C7.40039 6.40305 6.80344 7 6.06706 7C5.33068 7 4.73372 6.40305 4.73372 5.66667C4.73372 4.93029 5.33068 4.33333 6.06706 4.33333C6.80344 4.33333 7.40039 4.93029 7.40039 5.66667Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

export default viLoopImage;
